// Imports => Utilities
import {AcLockObject} from '../utilities/ac-lock-object';

export const POSITIONS = AcLockObject({
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  BEFORE: 'before',
  AFTER: 'after',
});

export const SIZES = AcLockObject({
  SMALL: 'small',
  DEFAULT: 'default',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra_large',
});

export const THEMES = AcLockObject({
  ALPHA: 'alpha',
  ALPHA_LIGHT: 'alpha_light',
  ALPHA_MEDIUM: 'alpha_medium',
  ALPHA_DARK: 'alpha_dark',
  ALPHA_PITCH: 'alpha_pitch',
  OMEGA: 'omega',
  OMEGA_LIGHT: 'omega_light',
  OMEGA_MEDIUM: 'omega_medium',
  OMEGA_DARK: 'omega_dark',
  OMEGA_PITCH: 'omega_pitch',
  BETA: 'beta',
  BETA_LIGHT: 'beta_light',
  BETA_LIGHTEST: 'beta_lightest',
  BETA_MEDIUM: 'beta_medium',
  BETA_DARK: 'beta_dark',
  CHARLIE: 'charlie',
  CHARLIE_LIGHT: 'charlie_light',
  ECHO: 'echo',
  ECHO_LIGHT: 'echo_light',
  ECHO_DARK: 'echo_dark',
  DEFAULT: 'default',
  TRANSPARENT: 'transparent',
  WHITE: 'white',
  EGGWHITE: 'eggwhite',
  OFFWHITE: 'offwhite',
  LIGHT: 'light',
  SUBTLE: 'subtle',
  MEDIUM: 'medium',
  DARK: 'dark',
  PITCH: 'pitch',
  BLACK: 'black',
  PLACEHOLDER: 'placeholder',
  PATTERN: 'pattern',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  TWITTER: 'twitter',
  SUCCESS: 'success',
  SUCCESS_LIGHT: 'success_light',
  ERROR: 'error',
  ERROR_LIGHT: 'error_light',
  WARNING: 'warning',
  WARNING_LIGHT: 'warning_light',
  DANGER: 'danger',
  INFO: 'info',
  INFO_LIGHT: 'info_light',
});

export const TYPES = AcLockObject({
  TEXT: 'text',
  TEXTAREA: 'textarea',
  PASSWORD: 'password',
  NUMBER: 'number',
  EMAIL: 'email',
  IBAN: 'iban',
  CODE: 'code',
  STRING: 'string',
  BOOLEAN: 'boolean',
  DATE: 'date',
  ALPHANUMERIC: 'alphanumeric',
  NUMERIC: 'numeric',
  ZIPCODE: 'zipcode',
  CHECKBOX: 'checkbox',
  TOGGLE: 'toggle',
  RADIO: 'radio',
  SUBMIT: 'submit',
  RESET: 'reset',
  BUTTON: 'button',
  BACKGROUND: 'background',
  IMAGE: 'image',
  ICON: 'icon',
  WEBSITE: 'website',
  HIDDEN: 'hidden',
  DELETE: 'delete',
  LINK: 'link',
  SELECT: 'select',
  ON_OFF: 'on_off',
  DOUBLE: 'double',
  RAITING: 'rating',
});

export const VARIANTS = AcLockObject({
  OUTLINE: 'outline',
  DEFAULT: 'default',
  SUBTLE: 'subtle',
  TEXT: 'text',
  GHOST: 'ghost',
  FILL: 'fill',
  TRANSPARENT: 'transparent',
  UPPERCASE: 'uppercase',
  LOWERCASE: 'lowercase',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  HELP: 'help',
  PLACEHOLDER: 'placeholder',
  SOLID: 'solid',
  DASHED: 'dashed',
  DOTTED: 'dotted',
});
